import { useId } from "react";

import { DateTimeField } from "../../components/DateTimeField";

type Props = {
  /** HH:MM, or "" while there's none. */
  value: string;
  onChange: (value: string) => void;
  /** Its accessible name ("Início", "Hora"…). */
  label: string;
  disabled?: boolean;
  /** Shown while there's no time. */
  placeholder?: string;
  /** As tall as the editor's other fields (a form), or compact (a list of intervals). */
  size?: "field" | "compact";
};

/** A time of the agenda: the editor's date and time field (the published form's picker), for a time. */
export const TimePicker = ({ value, onChange, label, disabled, placeholder, size = "compact" }: Props) => {
  const id = useId();
  return (
    <DateTimeField
      id={id}
      kind="TIME"
      label={label}
      value={value}
      disabled={disabled}
      placeholder={placeholder}
      size={size}
      onChange={onChange}
    />
  );
};
